import { render, staticRenderFns } from "./ManageDiscount.vue?vue&type=template&id=3a2cb15f&"
import script from "./ManageDiscount.vue?vue&type=script&lang=js&"
export * from "./ManageDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports